import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../../../../core/providers/apiservices';
import { ControlDTO } from '../../../../core/data/ControlDTO';
import { CampaignDTO } from '../data/CampaignDTO';
import { CampaignItemDTO } from '../data/CampaignItemDTO';
import { CampaignItemFileDTO } from '../data/CampaignItemFileDTO';
import { ErrorDTO } from '../../../../core/data/ErrorDTO';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CampaignItemFileProvider {
  private header = APIService.getHeader();
  itemret: any;

  constructor(public http: HttpClient, private translate: TranslateService) {}

  /**
   * GET campaigns
   */
  get(guidCampaignItem:string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = `${APIService.API_URL}campaignitemfile?guidCampaignItem=${guidCampaignItem}`;
      this.http.get(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:ControlDTO = response;
          resolve(jsonData);

        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

 
  /**
   * DELETE campaign item file by campaignItemId and fileId
   */
  delete(guidCampaignItem?: string, guid?: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `campaignitemfile?guidCampaignItem=${guidCampaignItem}&guid=${guid}`;
      this.http.delete(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData = response as CampaignItemFileDTO;
          resolve (jsonData);
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }
}
